"use client";

import { c as _c } from "react/compiler-runtime";
import { SEOContentForProjectOrSup } from "@/components/sup/seo/content-project-sup";
import { useTotalCountFetch } from "@/hooks/use-total-count-fetch";
import { useUrlFilters } from "@/hooks/use-url-filters";
import { useSearchPageMapData } from "@/providers/search";
import { memo, useMemo } from "react";

/**
 * Wrapper for SeoBanner on search pages
 * Provides search-specific data from filters and map context
 */
export const SEOContentForSearch = memo(function SEOContentForSearch() {
  const $ = _c(20);
  const {
    filters
  } = useUrlFilters();
  let rest;
  if ($[0] !== filters) {
    const {
      bounds: _bounds,
      coordinates: _coordinates,
      zoom: _zoom,
      ...t0
    } = filters;
    rest = t0;
    $[0] = filters;
    $[1] = rest;
  } else {
    rest = $[1];
  }
  let cleanedFilters;
  if ($[2] !== rest) {
    cleanedFilters = {};
    for (const [key, value] of Object.entries(rest)) {
      if (Array.isArray(value) && value.length === 0) {
        continue;
      }
      if (value === undefined) {
        continue;
      }
      cleanedFilters[key] = value;
    }
    $[2] = rest;
    $[3] = cleanedFilters;
  } else {
    cleanedFilters = $[3];
  }
  const filtersWithoutBounds = cleanedFilters as Partial<typeof rest>;
  let t0;
  if ($[4] !== filtersWithoutBounds) {
    t0 = {
      filters: filtersWithoutBounds,
      enabled: true
    };
    $[4] = filtersWithoutBounds;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  useTotalCountFetch(t0);
  const totalCountWithoutBounds = useSearchPageMapData(_temp);
  const bedrooms = filters.bedrooms?.min;
  let t1;
  if ($[6] !== filters.locations) {
    t1 = filters.locations?.find(_temp2)?.name;
    $[6] = filters.locations;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const locality = t1;
  let t2;
  if ($[8] !== filters.locations) {
    t2 = filters.locations?.find(_temp3)?.name;
    $[8] = filters.locations;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const project = t2;
  const t3 = totalCountWithoutBounds ?? undefined;
  let t4;
  if ($[10] !== bedrooms) {
    t4 = bedrooms ? [bedrooms] : undefined;
    $[10] = bedrooms;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== filters.propertyType) {
    t5 = filters.propertyType ? [filters.propertyType] : undefined;
    $[12] = filters.propertyType;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== locality || $[15] !== project || $[16] !== t3 || $[17] !== t4 || $[18] !== t5) {
    t6 = <SEOContentForProjectOrSup availableUnitsCount={t3} availableBedrooms={t4} locality={locality} projectName={project} propertyTypes={t5} />;
    $[14] = locality;
    $[15] = project;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  return t6;
});
function _temp(state) {
  return state.totalCountWithoutBounds;
}
function _temp2(loc) {
  return loc.type === "landmark";
}
function _temp3(loc_0) {
  return loc_0.type === "project";
}